
<div class="screen-spacer"></div>
<div class="detail-wrapper page-content" [ngClass]="getClass()"  >
	<app-is-in-view class="is-in-view" ></app-is-in-view>
	<div class="side-detail-spacer"></div>
	<ng-container *ngFor="let article of (currentDetail$ | push)">
		<app-article [article]="processArticle(article)" ></app-article>		
	</ng-container>
	
	<div class="detail-thumbnails" *ngIf="(thumbnails$ | push) as thumbnails">
		<p class="next-items-label" *ngIf="thumbnails.length !== 0" >následující položky v sekci </p>
		<div class="thumbnail-wrapper" *ngFor="let article of thumbnails">
		  <app-thumbnail [article]="article" ></app-thumbnail>
		</div>
	</div>
	<div class="side-detail-spacer"></div>
</div>

<nav class="back-btn">
	<app-back-btn 
		class="detail-back-btn" 
		[currentTaxonomyPage$]="currentTaxonomyPage$"
		[route$]="route$"
		[showIcon]="false"
	></app-back-btn>
</nav>

<app-page-bottom></app-page-bottom>
 
  